import { Moment } from 'moment/moment';

export default class SurveyResult {
  value = 0;
  max = 0;
  comment: string | null = null;
  source: string | null = null; // Email of tel
  createdOn: Moment | null = null;
}
